import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import API from "../api"; // ton instance axios

export default function VerifyEmail() {
    const [message, setMessage] = useState("Vérification en cours...");
    const [isVerified, setIsVerified] = useState(false);
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    useEffect(() => {
        if (!token) {
        setMessage("Lien de vérification invalide.");
        return;
        }

        const verifyEmail = async () => {
        try {
            const res = await API.get(`/api/auth/verify-email?token=${token}`);
            setMessage(res.data);
            setIsVerified(true); // bouton login activé seulement si succès
        } catch (err) {
            console.error(err);
            if (err.response && err.response.data) {
            setMessage(err.response.data);
            } else {
            setMessage("Erreur lors de la vérification. Réessayez plus tard.");
            }
        }
        };

        verifyEmail();
    }, [token]);

    return (
        <div className="relative min-h-screen bg-[#0D1117] flex items-center justify-center px-4 sm:px-6 lg:px-8">
        {/* Background graphique */}
        <div className="absolute bottom-0 right-0 overflow-hidden lg:inset-y-0">
            <div className="w-auto h-full bg-gradient-to-tr from-[#1F6FEB]/20 to-[#3B82F6]/10 rounded-full transform rotate-45 scale-150"></div>
        </div>

        {/* Container */}
        <div className="relative z-10 w-full max-w-md bg-[#161B22] rounded-2xl shadow-[0_0_20px_#3B82F6]/20 p-8 mt-20">
            <h2 className="text-3xl font-bold text-center text-[#E6EDF3] mb-2 font-pj">
            Email Verification
            </h2>
            <p className="text-center text-[#8B949E] mb-8">{message}</p>

            {isVerified && (
            <div className="flex justify-center">
                <Link
                to="/login"
                className="w-full py-3 text-white bg-[#1F6FEB] hover:bg-[#388BFD] rounded-xl font-semibold transition shadow-[0_0_10px_#1F6FEB]/30 text-center"
                >
                Go to Login
                </Link>
            </div>
            )}
        </div>
        </div>
    );
}

